'use client';

import React from 'react';
import Link from 'next/link';

import styles from '../../../styles/components/ui/button.module.scss';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  icon,
  iconPosition = 'left',
  fullWidth = false,
  className = '',
  onClick,
  type = 'button',
  href,
  ...props
}) => {
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth && styles.fullWidth,
    disabled && styles.disabled,
    loading && styles.loading,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const renderIcon = () => {
    if (!icon) {
      return null;
    }

    const iconElement =
      typeof icon === 'string' ? <span className={styles.icon}>{icon}</span> : icon;

    return <span className={`${styles.iconWrapper} ${styles[iconPosition]}`}>{iconElement}</span>;
  };

  const renderContent = () => {
    if (loading) {
      return (
        <>
          <svg
            className={styles.spinner}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 12a9 9 0 11-6.219-8.56" />
          </svg>
          <span>Зареждане...</span>
        </>
      );
    }

    return (
      <>
        {iconPosition === 'left' && renderIcon()}
        <span className={styles.text}>{children}</span>
        {iconPosition === 'right' && renderIcon()}
      </>
    );
  };

  if (href && !disabled && !loading) {
    return (
      <Link href={href} className={buttonClasses} onClick={onClick} {...props}>
        {renderContent()}
      </Link>
    );
  }

  return (
    <button
      type={type}
      className={buttonClasses}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {renderContent()}
    </button>
  );
};

export default Button;
